import { useState } from "react";
import {
    SectionsHeadersMenuItemsMapping,
    PRODUCTS_MENU_ID,
    USE_CASES_MENU_ID,
    FEATURES_MENU_ID,
    RESOURCES_MENU_ID, mobileProductsSectionMenuItems
} from "segments/desktop/header/layouts/base-header/base-header-service";
import { PRICING_PAGE_LINK, CONTACT_US_FROM_HEADER_PAGE_LINK, LOGIN_PAGE_LINK } from "constants/links";
import { getMiniSitePricingPageLink } from "client/services/cluster-config-service/cluster-config-service";
import { componentStyles } from "./header-menu-component.scss";
import LinkWithSectionsMenuComponent from "./link-with-menu/link-with-sections-menu-component";
import LinkComponent from "./link/link-component";
import DownloadMobileAppComponent from "./download-mobile-app/download-mobile-app-component";
import { withGenericConfig } from "/contexts/generic-config-context";
import { withAbTests } from "/contexts/ab-tests-context";

const HeaderMenuComponent = (props) => {
  const [openedMenuId, setOpenedMenuId] = useState(null);
  const { isMinisitePage, pageClusterConfig, useProductMiniSiteConfig } = props;

  const openLinksMenu = (menuId) => {
    setOpenedMenuId(menuId);
  };

  const getPricingPageLink = () => {
    let minisitePricingPageLink = null;
    if (isMinisitePage) {
      minisitePricingPageLink = getMiniSitePricingPageLink(pageClusterConfig, { useProductMiniSiteConfig });
    }

    return minisitePricingPageLink || PRICING_PAGE_LINK;
  };

  return (
    <div className="header-menu-mobile-component">
      <LinkWithSectionsMenuComponent
        id={PRODUCTS_MENU_ID}
        title="header.products"
        links={mobileProductsSectionMenuItems}
        openLinksMenu={openLinksMenu}
        isOpen={openedMenuId === PRODUCTS_MENU_ID}
      />
      <LinkWithSectionsMenuComponent
        id={USE_CASES_MENU_ID}
        title="header.useCases"
        links={SectionsHeadersMenuItemsMapping[USE_CASES_MENU_ID]}
        openLinksMenu={openLinksMenu}
        isOpen={openedMenuId === USE_CASES_MENU_ID}
      />
      <LinkWithSectionsMenuComponent
        id={FEATURES_MENU_ID}
        title="header.features"
        links={SectionsHeadersMenuItemsMapping[FEATURES_MENU_ID]}
        openLinksMenu={openLinksMenu}
        isOpen={openedMenuId === FEATURES_MENU_ID}
      />
      <LinkWithSectionsMenuComponent
        id={RESOURCES_MENU_ID}
        title="header.resources"
        links={SectionsHeadersMenuItemsMapping[RESOURCES_MENU_ID]}
        openLinksMenu={openLinksMenu}
        isOpen={openedMenuId === RESOURCES_MENU_ID}
      />
      <LinkComponent title="header.pricing" url={getPricingPageLink()} />

      <LinkComponent title="header.contactSales" url={CONTACT_US_FROM_HEADER_PAGE_LINK} />

      <LinkComponent title="header.logIn" url={LOGIN_PAGE_LINK} />

      <div className="download-mobile-app-component-wrapper">
        <DownloadMobileAppComponent />
      </div>

      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default withGenericConfig(withAbTests(HeaderMenuComponent));
